import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, take } from 'rxjs';
import { SeattixState } from 'src/app/2dmap/types';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TwoDMapService {
  constructor(private http: HttpClient) {}

  getMap(mapUrl: string): Promise<SeattixState> {
    const url =
      mapUrl.indexOf('http') !== -1
        ? mapUrl
        : `${environment.baseUrl}${mapUrl}`;
    return lastValueFrom<any>(this.http.get(url).pipe(take(1)));
  }
}
